export var getVariant = function getVariant(variants, variantId, amount) {
  var variant = variants[0];

  if (variantId) {
    variant = variants.find(function (vari) {
      return vari.id === variantId;
    }) || variant;
  } else if (amount) {
    variant = variants.find(function (vari) {
      return vari.price === amount;
    }) || variant;
  }

  return variant;
};
export var cleanVariants = function cleanVariants(data) {
  var variants = data.variants;
  var vars = [];
  variants.forEach(function (variant) {
    var available = variant.available,
        compareAtPrice = variant.compare_at_price,
        id = variant.id,
        inventoryQuantity = variant.inventory_quantity,
        option1 = variant.option1,
        price = variant.price,
        sku = variant.sku;
    vars.push({
      available: available,
      compareAtPrice: compareAtPrice / 100,
      option1: option1,
      id: id,
      inventoryQuantity: inventoryQuantity,
      price: price / 100,
      sku: sku
    });
  });
  return vars;
};